import { memo, useState } from 'react';
import { Stack, Text } from '@chakra-ui/react';

import RequirementMatchCollapsible from './RequirementMatchCollapsible';
import { InterviewAnalysisResult, ScreeningAnalysisResult } from '@/types/AnalysisResult';

interface RequirementsMatchSectionProps {
  analysisResult: InterviewAnalysisResult | ScreeningAnalysisResult;
}

const RequirementsMatchSection = memo(({ analysisResult }: RequirementsMatchSectionProps) => {
  const [alignedItemsOpen, setAlignedItemsOpen] = useState(true);
  const [gapsOpen, setGapsOpen] = useState(true);

  return (
    <Stack>
      <Text color="neutrals.900" fontSize="18px" fontWeight="semibold" mb="8px">
        Requirements Match
      </Text>
      <Text fontSize="16px" color="neutrals.700" mb="24px">
        This section provides our evaluation of candidate interviews, highlighting key aligned items
        and misaligned items for quick assessment of overall suitability.
      </Text>
      <RequirementMatchCollapsible
        title="Aligned Items"
        matchType="aligned"
        items={analysisResult.aligned_skills}
        isOpen={alignedItemsOpen}
        setOpen={setAlignedItemsOpen}
      />
      <RequirementMatchCollapsible
        title="Misaligned Items"
        matchType="misaligned"
        items={analysisResult.gaps_or_misalignments}
        isOpen={gapsOpen}
        setOpen={setGapsOpen}
      />
    </Stack>
  );
});

RequirementsMatchSection.displayName = 'RequirementsMatchSection';

export default RequirementsMatchSection;
